//import
import './build/setVers.js';
import './build/pagetop.js';
import './build/anchor.js';
import './build/form.js';
import './build/HeaderNavigation.js';
import './build/formAgreeWP.js';
import './build/formErrorWP.js';
import './build/formInputWP.js';
import './build/formConfirmWP.js';
import './build/formCheckbox.js';
import './build/addHeaderAnchor.js';

// [クラス作成] observerで表示するオブジェクト
/**============================================================
*   [Animation] observerでアニメーション用クラス付与
*   target : .p-animation-observer
============================================================*/
import observerShowObj from './build/observerShowObj';
const observerElem = document.getElementsByClassName('p-animation-observer');
const createObserveObj = () => {
  if (!observerElem.length) return;
  for (let i = 0; i < observerElem.length; i++) {
    new observerShowObj(observerElem[i]);
  }
}
document.addEventListener('DOMContentLoaded', createObserveObj, false);

/**============================================================
*   [Animation] SVGテキストストローク
*   target : .js-animate-text-stroke
============================================================*/
import AnimateTextStroke from './build/AnimateTextStroke';
const AnimateTextStrokeElem = document.querySelectorAll('.js-animate-text-stroke');
const createAnimateTextStrokeObj = () => {
  if (!AnimateTextStrokeElem.length) return;
  for (let i = 0; i < AnimateTextStrokeElem.length; i++) {
    new AnimateTextStroke(AnimateTextStrokeElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createAnimateTextStrokeObj, false);

/**============================================================
*   [MicroModal]
============================================================*/
import MicroModal from 'micromodal';
MicroModal.init({
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  onShow: ()=>{
    document.getElementsByTagName('html')[0].classList.add('is-modal-opened');
  },
  onClose: ()=>{
    document.getElementsByTagName('html')[0].classList.remove('is-modal-opened');
  }
});

/**============================================================
*   [lottie]
============================================================*/
import lottieImage from './build/lottieImage';
const lottieLoader = document.getElementsByClassName('js-lottie');
const observeLottieAnimation = () => {
    if (!lottieLoader.length) return;
    for (let i = 0; i < lottieLoader.length; i++) {
      new lottieImage(lottieLoader[i]);
    }
}
document.addEventListener('DOMContentLoaded', observeLottieAnimation, false);

/**============================================================
*   [共通] 高さ揃え
*   target : [親] .js-fix-height-box
*            [子] .js-fix-height-box__item
============================================================*/
import FixHeight from './build/FixHeight';
const fixHeightElem = document.getElementsByClassName('js-fix-height-box');
const FixHeightObj = () => {
    if (!fixHeightElem.length) return;
    for (let i = 0; i < fixHeightElem.length; i++) {
      new FixHeight(fixHeightElem[i]);
    }
}
document.addEventListener('DOMContentLoaded', FixHeightObj, false);

/**============================================================
*   [共通] ラジオボタン表示切り替え・グラデマスクアコーディオン
*   target : .js-toggle-navigation
============================================================*/
import { createApp } from 'vue';
import ToggleNavigation from './build/ToggleNavigation.vue';
window.addEventListener('DOMContentLoaded', () => {
  createApp(ToggleNavigation).mount('.js-toggle-navigation');
})

/**============================================================
*   [共通] アコーディオングループ
*   target : .js-toggle-accordion
============================================================*/
import ToggleAccordion from './build/ToggleAccordion.vue';
window.addEventListener('DOMContentLoaded', () => {
  createApp(ToggleAccordion).mount('.js-toggle-accordion');
})

/**============================================================
*   [共通] blog記事スライダー
*   target : .p-archive-slider
============================================================*/
import ArchiveSlider from './build/ArchiveSlider';
const ArchiveSliderElem = document.getElementsByClassName('p-archive-slider');
const createArchiveSliderObj = () => {
  if (!ArchiveSliderElem.length) return;
  for (let i = 0; i < ArchiveSliderElem.length; i++) {
    new ArchiveSlider(ArchiveSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createArchiveSliderObj, false);

/**============================================================
*   [共通] blog記事バナースライダー
*   target : .p-archive-banner-slider
============================================================*/
import ArchiveBannerSlider from './build/ArchiveBannerSlider';
const ArchiveBannerSliderElem = document.getElementsByClassName('p-archive-banner-slider');
const createArchiveBannerSliderObj = () => {
  if (!ArchiveBannerSliderElem.length) return;
  for (let i = 0; i < ArchiveBannerSliderElem.length; i++) {
    new ArchiveBannerSlider(ArchiveBannerSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createArchiveBannerSliderObj, false);

/**============================================================
*   [TOP] caseスライダー
*   target : .p-top-case__slider
============================================================*/
import TopCaseSlider from './build/TopCaseSlider';
const CaseSliderElem = document.getElementsByClassName('p-top-case__slider');
const createCaseSliderObj = () => {
  if (!CaseSliderElem.length) return;
  for (let i = 0; i < CaseSliderElem.length; i++) {
    new TopCaseSlider(CaseSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createCaseSliderObj, false);

/**============================================================
*   [Blog] もっと見るブロック
*   target : .js-archive-more
============================================================*/
import BlogArchiveMore from './build/BlogArchiveMore';
const BlogArchiveMoreElem = document.getElementsByClassName('js-archive-more');
const BlogArchiveMoreObj = () => {
  if (!BlogArchiveMoreElem.length) return;
  for (let i = 0; i < BlogArchiveMoreElem.length; i++) {
    new BlogArchiveMore(BlogArchiveMoreElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', BlogArchiveMoreObj, false);

/**============================================================
*   [viewport] 375px以下画面は縮小
============================================================*/
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth >= 375
        ? 'width=device-width,initial-scale=1'
        : 'width=375';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();

/**============================================================
*   [Service] caseスライダー
*   target : .p-service-case__slider
============================================================*/
import ServiceCaseSlider from './build/ServiceCaseSlider';
const ServiceCaseSliderElem = document.getElementsByClassName('js-service-case__slider');
const createServiceCaseSliderObj = () => {
  if (!ServiceCaseSliderElem.length) return;
  for (let i = 0; i < ServiceCaseSliderElem.length; i++) {
    new ServiceCaseSlider(ServiceCaseSliderElem[i], i, '.js-service-case__slider');
  }
}
document.addEventListener('DOMContentLoaded', createServiceCaseSliderObj, false);

/**============================================================
*   [Service] サービスリストスライダー
*   target : .p-service-list-slide
============================================================*/
import ServiceListSlider from './build/ServiceListSlider';
const ServiceListSliderElem = document.getElementsByClassName('p-service-list-slide');
const ServiceListSliderObj = () => {
  if (!ServiceListSliderElem.length) return;
  for (let i = 0; i < ServiceListSliderElem.length; i++) {
    new ServiceListSlider(ServiceListSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', ServiceListSliderObj, false);

/**============================================================
*   [Service] サービスステップスライダー
*   target : .p-service-step-slide
============================================================*/
import ServiceStepSlider from './build/ServiceStepSlider';
const ServiceStepSliderElem = document.getElementsByClassName('p-service-step-slide');
const ServiceStepSliderObj = () => {
  if (!ServiceListSliderElem.length) return;
  for (let i = 0; i < ServiceStepSliderElem.length; i++) {
    new ServiceStepSlider(ServiceStepSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', ServiceStepSliderObj, false);

/**============================================================
*   [Service] workflowスライダー
*   target : .p-service-workflow-slider
============================================================*/
import ServiceWorkflowSlider from './build/ServiceWorkflowSlider';
const ServiceWorkflowSliderElem = document.getElementsByClassName('js-service-workflow-slider');
const createServiceWorkflowSliderObj = () => {
  if (!ServiceWorkflowSliderElem.length) return;
  for (let i = 0; i < ServiceWorkflowSliderElem.length; i++) {
    new ServiceWorkflowSlider(ServiceWorkflowSliderElem[i], i, '.js-service-workflow-slider');
  }
}
document.addEventListener('DOMContentLoaded', createServiceWorkflowSliderObj, false);

/**============================================================
*   [Plan] Planスライダー
*   target : .p-plan-archive-slider
============================================================*/
import PlanArchiveSlider from './build/PlanArchiveSlider';
const PlanArchiveSliderElem = document.getElementsByClassName('p-plan-archive-slider');
const createPlanArchiveSliderObj = () => {
  if (!PlanArchiveSliderElem.length) return;
  for (let i = 0; i < PlanArchiveSliderElem.length; i++) {
    new PlanArchiveSlider(PlanArchiveSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createPlanArchiveSliderObj, false);

/**============================================================
*   [Plan] Planスライダー
*   target : .p-archive-list-slider
============================================================*/
import PlanListSlider from './build/PlanListSlider';
const PlanListSliderElem = document.getElementsByClassName('p-plan-list-slider');
const createPlanListSliderObj = () => {
  if (!PlanListSliderElem.length) return;
  for (let i = 0; i < PlanListSliderElem.length; i++) {
    new PlanListSlider(PlanListSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createPlanListSliderObj, false);
